import strings from '../../Localization/Localization';

let price = {
  fieldKey: "price",
  type: "price",
  label: strings.form.appointmentActionPreviousPrice.price.label,
  validators: []
}

let quantityCredit = {
  fieldKey: "quantity_credit",
  type: "text",
  label: strings.form.appointmentActionPreviousPrice.quantityCredit.label,
  validators: []
}

let modifiedAt = {
  fieldKey: "modified_at",
  type: "date",
  label: strings.form.appointmentActionPreviousPrice.modifiedAt.label,
  validators: []
}

export const form = {
  formKey: "appointmentActionPreviousPrice",
  fields: [
    price,
    quantityCredit,
    modifiedAt
  ]
}
